import React, { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { PORTFOLIO, FILTERS } from "../../data/content";

export default function Portfolio() {
  const [filter, setFilter] = useState("all");

  return (
    <section id="portfolio" data-testid="portfolio-section" className="section-pad relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="overline mb-4">Selected Work</div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl md:text-6xl leading-none tracking-tight mb-10">
            Notable <span className="text-amber">Ventures.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="flex flex-wrap gap-3 mb-10">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${f.key}`}
              onClick={() => setFilter(f.key)}
              className={`rounded-full px-5 py-2 text-sm font-medium transition-colors duration-300 border ${
                filter === f.key
                  ? "bg-amber text-obsidian border-amber"
                  : "border-white/10 text-ink-secondary hover:text-ink hover:border-white/25"
              }`}
            >
              {f.label}
            </button>
          ))}
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {PORTFOLIO.map((p, i) => {
            const dim = filter !== "all" && p.category !== filter;
            const wide = p.span === "wide";
            return (
              <a
                key={p.title}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`portfolio-item-${i}`}
                className={`group relative block overflow-hidden rounded-xl border border-white/[0.07] h-80 transition-all duration-300 hover:border-amber/40 ${
                  wide ? "md:col-span-8" : "md:col-span-4"
                } ${dim ? "opacity-25 scale-[0.98]" : "opacity-100"}`}
              >
                <img
                  src={p.img}
                  alt={p.title}
                  className="absolute inset-0 h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/55 to-transparent" />
                <span className="absolute top-5 right-5 h-10 w-10 rounded-full bg-obsidian/60 border border-white/15 flex items-center justify-center text-ink opacity-100 md:opacity-0 md:-translate-y-1 md:group-hover:opacity-100 md:group-hover:translate-y-0 transition-all duration-300">
                  <ArrowUpRight size={18} />
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h4 className="font-display text-2xl font-semibold">{p.title}</h4>
                  <p className="text-amber text-xs mt-1 uppercase tracking-[0.14em]">{p.meta}</p>
                  <p className="text-ink-secondary text-sm mt-3 max-w-md leading-relaxed opacity-100 max-h-24 md:opacity-0 md:max-h-0 md:group-hover:opacity-100 md:group-hover:max-h-24 transition-all duration-500 overflow-hidden">
                    {p.desc}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
